import { Component } from '@angular/core';
import { ConnectionCreated, NodeConnectionData } from 'src/app/core/interface/flow-builder.interface';
import { FlowBuilderService } from 'src/app/core/service/flow-builder.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-filter-node',
  templateUrl: './filter-node.component.html',
  styleUrls: ['./filter-node.component.scss']
})
export class FilterNodeComponent {

  public selectedValue!: string;
  public operator!: string;
  public selectdData!: { value: string; };

  private subs: SubSink = new SubSink();
  public comparators: any[] = [{ key: 'Equals to', value: 'Equals to' }, { key: 'Not equals to', value: 'Not equals to' }, { key: 'Contains', value: 'Contains' },
  { key: 'Doesnt contains', value: 'Doesnt contains' }, { key: 'Starts with', value: 'Starts with' }, { key: 'Ends with', value: 'Ends with' },
  { key: 'Greater than', value: 'Greater than' }, { key: 'Less than', value: 'Less than' }, { key: 'Greater than or equal to', value: 'Greater than or equal to' },
  { key: 'Less than or equal to', value: 'Less than or equal to' }];


  constructor(
    public _fb: FlowBuilderService,
  ) {
    this.subs.add(
      this._fb.nodeConnectionCreated$.subscribe((res: ConnectionCreated) => {
        if (+res.input_id === this._fb?.activeNode?.id) {
          this.checkForConnectionData();
        }
      })
    );
  }

  ngOnInit(): void {
    this.checkForConnectionData();
  }


  checkForConnectionData() {
    const nodeDetailsById = this._fb.editor?.getNodeFromId(this._fb?.activeNode?.id);
    if (nodeDetailsById?.inputs['input_1']?.connections?.length !== 0) {
      const sourceNodeIndex = this._fb.drawnNodeList?.findIndex((sourceIndex:any) => sourceIndex?.id?.toString() === nodeDetailsById?.inputs['input_1']?.connections[0]?.node?.toString());
      this.setTableHeader(this._fb?.drawnNodeList[sourceNodeIndex]);
    }
  }


  setTableHeader(sourceNode: NodeConnectionData) {
    try {
      const activeNode = this._fb?.activeNode;
      const key:any = [];

      if (!activeNode?.connection) {
        activeNode.connection = {};
      }
      if (sourceNode?.name == 'Select') {
        sourceNode.reFormat?.forEach((selData:any) => {
          if (selData?.updatedName == null && selData?.checked == true) {
            key.push(selData?.originalName);
          } else if (selData?.updatedName != null && selData?.checked == true) {
            key.push(selData?.updatedName);
          }
        });

        activeNode.filterFormat = [];
        for (let i = 0; i < key?.length; i++) {
          activeNode?.filterFormat?.push({ key: key[i], value: key[i] });
        }

        activeNode.connection = sourceNode?.connection;
      } else {
        activeNode.connection.gridData = sourceNode?.connection?.gridData;
        const data = Object.keys(sourceNode?.connection?.gridData[0]);
        activeNode.filterFormat = [];
        for (let i = 0; i < data?.length; i++) {
          activeNode?.filterFormat?.push({ key: data[i], value: data[i] });
        }
      }

    } catch (error) {
      return;
    }

  }



  DataChange(value:any) {
    this.selectdData = value;
    this._fb.activeNode.selectedFilter = value?.value;
  }

  OperatorChange(value:any) {
    this._fb.selectedFilterOperator = value;
    this._fb.activeNode.operator = value?.value;

  }

}
